import { render, staticRenderFns } from "./EnglishQuizzes.vue?vue&type=template&id=0cb56a81&scoped=true&"
import script from "./EnglishQuizzes.vue?vue&type=script&lang=js&"
export * from "./EnglishQuizzes.vue?vue&type=script&lang=js&"
import style0 from "./EnglishQuizzes.vue?vue&type=style&index=0&id=0cb56a81&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0cb56a81",
  null
  
)

component.options.__file = "EnglishQuizzes.vue"
export default component.exports